import { ID_REGISTER } from 'civil-status/components/shared/list-register';
import { CodeTypeAct } from 'civil-status/constants/code-type-act';
import { SectionVM } from 'civil-status/view-models/step-form';
import { DateTime } from 'luxon';
import { ModelEventoDTO } from 'shell/models/act-category-list';

export const transformerMatrimonioAttoNascitaSposo = (
  values?: ModelEventoDTO
): SectionVM | undefined => {
  const attoNascitaSposo = values?.datiEventoMatrimonio?.attoNascitaSposo;

  if (!attoNascitaSposo) {
    return;
  }

  const typeAct = Boolean(attoNascitaSposo?.idAnsc)
    ? CodeTypeAct.attoDigitale
    : CodeTypeAct.attoCartaceo;

  return {
    typeAct,
    actForm: {
      idAnsc: attoNascitaSposo?.idAnsc,
      dateAct: attoNascitaSposo?.dataformazione
        ? DateTime.fromISO(attoNascitaSposo?.dataformazione)
        : null,
      italian: attoNascitaSposo?.idComuneRegistrazione
        ? {
            municipality: {
              id: attoNascitaSposo?.idComuneRegistrazione || '',
              code: attoNascitaSposo?.idComuneRegistrazione
                ? Number.parseInt(attoNascitaSposo?.idComuneRegistrazione, 10)
                : undefined,
              description: attoNascitaSposo.nomeComuneRegistrazione || '',
              province: attoNascitaSposo.siglaProvinciaRegistrazione || '',
              idProvince: attoNascitaSposo.idProvinciaRegistrazione
                ? Number.parseInt(attoNascitaSposo.idProvinciaRegistrazione, 10)
                : undefined,
            },
          }
        : undefined,
      register: ID_REGISTER.NASCITA,
      year: attoNascitaSposo?.annoAtto || '',
      municipalNumber: attoNascitaSposo?.numeroatto || '',
      typeEvent: attoNascitaSposo?.idtipocontenuto || '',
      portion: attoNascitaSposo?.parte || '',
      serie: attoNascitaSposo?.serie || '',
      volume: attoNascitaSposo?.volume || '',
    },
  };
};
